import { render, staticRenderFns } from "./FeeManagement.vue?vue&type=template&id=483fb7b0"
import script from "./FeeManagement.vue?vue&type=script&lang=js"
export * from "./FeeManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports